import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { getTranslatedString } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';

import { getTemplate, getTemplateValue } from '../NoticeHelpers';

import SingleFileUpload from 'components/ui/SingleFileUpload/SingleFileUpload';
import Form from 'components/ui/Form';
import { imageAcceptedFileTypes } from 'helpers/FileHelper';

const config = {
  ATTACHMENT_SIZE: 6 * 1000000, // 6mb
  IMAGE_SIZE: 3 * 1000000,
};

const ImageInput = ({
  values,
  errors,
  touched,
  noticeTemplates,
  setFieldValue,
  setFieldTouched,
}) => {
  const allowImageTemplate = useMemo(() => {
    return getTemplateValue(
      getTemplate(noticeTemplates, values.notice_template_id),
      'allow_image_modify',
      true
    );
  }, [values.notice_template_id, noticeTemplates]);

  const canViewUploadedPhoto = useMemo(() => {
    return (
      allowImageTemplate || values.image !== undefined || !featureEnabled('notice_restrictions')
    );
  }, [allowImageTemplate, values.image]);

  const labelText = useMemo(() => {
    let text = getTranslatedString('landlordPortal.noticeForm.ifYouWouldLikeToAttach');
    if (!allowImageTemplate && values.image !== undefined) {
      text = getTranslatedString('landlordPortal.noticeForm.ifYouWouldLikeToDrawNoModify');
    } else if (!allowImageTemplate) {
      text = getTranslatedString('landlordPortal.noticeForm.ifYouWouldLikeToDrawNoUpload');
    }

    return text;
  }, [allowImageTemplate, values.image]);

  const handleChange = (image) => {
    setFieldValue('image', image);
    setFieldTouched('image', true);
    setFieldValue('remove_image', !image);
  };

  return (
    <Form.Item label={labelText}>
      {canViewUploadedPhoto && (
        <SingleFileUpload
          file={values.image}
          name="image"
          onChange={handleChange}
          onDropVerbiage={getTranslatedString('landlordPortal.noticeForm.attachments.dropFileHere')}
          dropFileVerbiage={getTranslatedString(
            'landlordPortal.noticeForm.attachments.dragAndDrop'
          )}
          browseVerbiage={getTranslatedString('landlordPortal.noticeForm.attachments.browse')}
          rejectFileError={getTranslatedString(
            'landlordPortal.noticeForm.attachments.cannotAcceptFile'
          )}
          maxSize={config.IMAGE_SIZE}
          acceptedFiles={imageAcceptedFileTypes}
          disabled={!allowImageTemplate && values.image}
        />
      )}
    </Form.Item>
  );
};

export default connect((store) => {
  return {
    noticeTemplates: store.landlordNotices.notice_templates,
  };
}, {})(ImageInput);
